import React from "react";

const Tags = ({ tag }) => {
  return (
    <span key={tag} className="bg-black/40 py-1 px-3 rounded-full text-xs">
      {tag.toLowerCase()}
    </span>
  );
};

export default Tags;
